/** Path segments that must never be treated as a business slug. */
export const RESERVED_SLUGS = new Set([
  "setup-password",
  "reset-password",
  "login",
  "register",
  "explore",
  "checkbalance",
  "checkbalacne",
  "oldexplore",
  "privacy-policy",
  "terms-of-service",
  "benefit",
  "category",
  "offers",
  "gift-card",
  "superlogin",
  "superadmin",
  "exampleresturant",
  "examplehotel",
  "examplefitness",
  "exampleretail",
  "examplebeauty",
  "exampleseasonal",
  "landing-v2",
  // Admin app routes (must not be treated as business slugs after logout)
  "dashboard",
  "giftcards",
  "orders",
  "promotion-orders",
  "customers",
  "reports",
  "settings",
  "redeem",
  "subscription",
]);

export function isReservedSlug(slug) {
  return slug != null && RESERVED_SLUGS.has(String(slug).toLowerCase());
}
